import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/planos'),
      name: 'planos_index',
      component: Index,
      meta: {
        permissions: ['administrator'],
        sidebarName: 'Planos',
      },
    },
  ],
};
